export default __webpack_public_path__ + "static/media/lock.fa1a5a52.png";